import { useQuery } from "@tanstack/react-query";
import { fetchGoals } from "../database-goals";
import { goalQueryKeys } from "../operations/goal-query-keys";
import { useUser } from "@/hooks/auth/use-user";

export function useGoalsQuery() {
  const { user } = useUser();
  return useQuery({
    queryKey: goalQueryKeys.user(user?.id || "anonymous"),
    queryFn: () => user ? fetchGoals(user.id) : [],
    enabled: !!user,
    staleTime: 0,
  });
}
